const readString = (value: unknown, key: string): string | undefined => {
  const property = (value as Record<string, unknown> | null | undefined)?.[key];
  return typeof property === 'string' ? property : undefined;
};

const readNumber = (value: unknown, key: string): number | undefined => {
  const property = (value as Record<string, unknown> | null | undefined)?.[key];
  return typeof property === 'number' ? property : undefined;
};

export const getApiErrorStatus = (error: unknown): number | undefined => {
  const direct = readNumber(error, 'statusCode') ?? readNumber(error, 'status');
  if (direct !== undefined) return direct;
  const response = (error as { response?: unknown } | null | undefined)?.response;
  return readNumber(response, 'status');
};

export const getApiDetail = (error: unknown): string | undefined => {
  const body = readString(error, 'body');
  const fallback = readString(error, 'detail');

  if (!body) return fallback;

  try {
    return readString(JSON.parse(body), 'detail') ?? fallback;
  } catch {
    return fallback;
  }
};

export const getApiErrorMessage = (error: unknown, fallback = 'An error occurred'): string => {
  const detail = getApiDetail(error) ?? readString(error, 'clientMessage');
  if (detail) return detail;

  // Only surface a raw `message` for errors that came back from the server (they carry an HTTP
  // status). Transport-level failures (network down, CORS, timeout) have no status and raw
  // messages like "fetch failed" that aren't fit for users — fall back to the friendly copy.
  if (getApiErrorStatus(error) !== undefined) {
    return readString(error, 'message') ?? fallback;
  }

  return fallback;
};
